import { render, staticRenderFns } from "./groupManageDia.vue?vue&type=template&id=cc3321be&scoped=true&"
import script from "./groupManageDia.vue?vue&type=script&lang=js&"
export * from "./groupManageDia.vue?vue&type=script&lang=js&"
import style0 from "./groupManageDia.vue?vue&type=style&index=0&id=cc3321be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3321be",
  null
  
)

export default component.exports